import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Action, MemoizedSelector, select, Store} from '@ngrx/store';
import {LoadPNSApplications} from '@portal-ng/PNSAdminEntities/actions/PNSApplication.actions';
import * as fromAdminEntitites from '@portal-ng/PNSAdminEntities/reducers';
import {IAppState} from '@portal-ng/PNSCore/reducers';
import {PNSApplicationService} from '@portal-ng/PNSServices/PNSApplication.service';
import {take} from 'rxjs/operators';

@Injectable()
export class PNSApplicationResolver implements Resolve<void> {

  constructor(private store: Store<IAppState>) {
  }

  entityName                               = 'Applications';
  selectMethod: MemoizedSelector<any, any> = fromAdminEntitites.getApplicationsLoaded;
  selectAction: Action                     = new LoadPNSApplications(PNSApplicationService.defaultSearch());

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.store.pipe(select(this.selectMethod), take(1)).subscribe((hasLoaded) => {
      if (!hasLoaded) {
        this.store.dispatch(this.selectAction);
      } else {
        console.info(this.entityName + ' loading skipped, ' + this.entityName + ' are already loaded.');
      }
    });
  }

}
